// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__EsignatureComponent__fieldContentLeft{text-align:left}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-common-react/components/EsignatureComponent/EsignatureComponent.module.scss"],"names":[],"mappings":"AAAA,4CACE,eAAA","sourcesContent":[".fieldContentLeft {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldContentLeft": "app__EsignatureComponent__fieldContentLeft"
};
export default ___CSS_LOADER_EXPORT___;
